import { FormControlLabel, Checkbox } from "@mui/material";
import { useFormContext, useController } from "react-hook-form";

import useTranslations from "helpers/hooks/useTranslations";

import { IQuotePermissions } from "helpers/interfaces";

interface IProps {
    permissions?: IQuotePermissions
}

function SelectDropShip({ permissions } : IProps) {

    const tm = useTranslations();
    const name ="shipping.dropShip"
    const { control } = useFormContext();
    const { field } = useController({
        name: name,
        control: control,
    });

    return <>
        <FormControlLabel 
            control={
                <Checkbox 
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    ref={field.ref}
                    checked={field.value}
                    disabled={!permissions?.dropShip ?? true}
                />} 
            label={tm.Get("Drop Ship")} 
        />    
    </>
}

export default SelectDropShip;